import newsletter from '../../assets/images/svg/newsletter.svg'
import keepGoing from '../../assets/images/svg/keep_going.svg'
import call from '../../assets/images/svg/call.svg'
import contact from '../../assets/images/svg/contact.svg'
import trash from '../../assets/images/svg/trash.svg'
import skipPayment from '../../assets/images/svg/skip_payment.svg'
import skipModeration from '../../assets/images/svg/skip_moderation.svg'
import communication from '../../assets/images/svg/communication.svg'
import checkmark from '../../assets/images/svg/checkmark.svg'

export default {
  newsletter,
  keepGoing,
  call,
  contact,
  trash,
  skipPayment,
  skipModeration,
  communication,
  checkmark,
}
